import React from 'react'
import { AddCredCard, AddCupom, ModalAddCpf, ModalObs, SelecionaHoraFixa } from '../../Modais'
import { ButtonAction, CompEsporte, Loading } from '../../Simple'
import { Grid, Typography, Divider, Tab, Tabs } from '@mui/material'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { IoIosArrowBack } from 'react-icons/io'
import { iconsPayment } from '../../../assets'
import { ChktBottom } from '../../Complex'
import { Services } from '../../../services'
import moment from 'moment'

import './stylesCkt.css'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import ResumoAgendamento from './ResumoAgendamento'
import { ToastMessages } from '../../ToastMessages'

export default function MobileCheckout() {
  const containRef = React.useRef(null)
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { sttCtxChkt, actionsChkt, modaisChkt, loadCh, pagamentosDisponiveis } =
    React.useContext(CheckoutContext)
  const { sttCtxAgend } = React.useContext(AgendamentoContext)

  const reagendamento = sttCtxAgend.reagendamento

  const pagamentoLocal =
    Object.keys(reagendamento).length > 0
      ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' ||
        reagendamento.formaPagamento === 'LOCAL' ||
        reagendamento.formaPagamento === 'DINHEIRO'
      : false

  const [observacao, setObservacao] = React.useState(
    Object.keys(reagendamento).length > 0 ? reagendamento.observacoes : '',
  )
  const [marginH, setMarginH] = React.useState(0)
  const [modalObs, setModalObs] = React.useState(false)
  const [selectedTab, setSelectedTab] = React.useState(1)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const avoidPaymentChange = text => {
    ToastMessages.paymentMethodCannotBeChanged(text)
  }

  React.useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setMarginH(entry.contentRect.height)
      }
    })

    if (containRef.current) {
      observer.observe(containRef.current)
    }

    return () => {
      if (containRef.current) {
        observer.unobserve(containRef.current)
      }
    }
  }, [containRef])

  const recebimentoPix =
    sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_pix_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_pix_fixo

  const recebimentoCartao =
    sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_cartao_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_cartao_fixo

  const recebimentoDinheiro =
    sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_dinheiro_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_dinheiro_fixo

  const recebimentoMaq =
    sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.recebimentos_maquina_local_avulso
      : sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.recebimentos_maquina_local_fixo

  if (loadCh.confirmar) {
    return (
      <div className='contain-loading'>
        <Loading text={'Confirmando o seu agendamento...'} />
      </div>
    )
  }

  return (
    <Grid
      container
      rowSpacing={0}
      padding={1}
      sx={{ height: `calc(100% - ${marginH}px)`, overflow: 'auto' }}
    >
      {modaisChkt.horaFx && (
        <SelecionaHoraFixa
          show={modaisChkt.horaFx}
          ClosedModal={() => {
            actionsChkt.handleModaisChkt('horaFx', false)
          }}
        />
      )}
      {modaisChkt.cupom && (
        <AddCupom
          show={modaisChkt.cupom}
          modoPay={[sttCtxChkt.selTotal, sttCtxChkt.selSinal]}
          formaPays={[
            sttCtxChkt.selCardCredit,
            sttCtxChkt.selPix,
            sttCtxChkt.selMaqCredit,
            sttCtxChkt.selDinheiro,
          ]}
          onClose={() => {
            actionsChkt.handleModaisChkt('cupom', false)
          }}
        />
      )}
      {modaisChkt.cpf && (
        <ModalAddCpf
          modal={modaisChkt.cpf}
          ClosedModal={() => {
            actionsChkt.handleModaisChkt('cpf', false)
          }}
        />
      )}
      {modalObs && (
        <ModalObs
          show={modalObs}
          value={observacao}
          onChange={value => {
            setObservacao(value)
          }}
          onClose={() => {
            setModalObs(false)
          }}
        />
      )}
      {modaisChkt.cartaoCredito && (
        <AddCredCard
          modal={modaisChkt.cartaoCredito}
          onClick={() => {}}
          mode={'select-card'}
          ClosedModal={() => {
            actionsChkt.handleModaisChkt('cartaoCredito', false)
          }}
        />
      )}
      <Grid container item xs={12} marginBottom={'20px'}>
        <IoIosArrowBack
          size='25px'
          color='#FF7043'
          className='icon-back-page'
          onClick={() => {
            actionsCtxEmps.handleSttPg('modePg', 'grade')
          }}
        />
        <Typography
          variant='h6'
          className='text-title-section'
          sx={{ fontSize: '22px', marginLeft: '5px' }}
        >
          {Object.keys(reagendamento).length > 0
            ? 'Resumo do reagendamento'
            : sttCtxChkt.horaFixaSelecionada !== null
              ? 'Resumo do Horário Fixo'
              : sttCtxChkt.diaria
                ? 'Resumo da Diária'
                : 'Resumo do Horário Avulso'}
        </Typography>
      </Grid>

      <Grid
        container
        spacing={0}
        sx={{ width: '100%', padding: '0px', justifyContent: 'center', alignItems: 'center' }}
      >
        {Object.keys(reagendamento).length > 0 && (
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label='Resumo do Agendamento Tabs'
            TabIndicatorProps={{
              sx: {
                height: 3,
                borderRadius: '8px 8px 0 0',
                transform: 'scaleX(0.5)',
              },
            }}
          >
            <Tab
              label={
                <Typography sx={{ textTransform: 'none', fontFamily: 'inherit' }}>Antes</Typography>
              }
            />
            <Tab
              label={
                <Typography sx={{ textTransform: 'none', fontFamily: 'inherit' }}>Novo</Typography>
              }
            />
          </Tabs>
        )}
        {selectedTab === 0 && (
          <ResumoAgendamento
            data={reagendamento.dataInicio}
            nomeEmpresa={reagendamento.empresa.nome}
            nomeQuadra={reagendamento.quadra.descricao}
            endereco={reagendamento.quadra.endereco}
            horario={[
              {
                idgrade: reagendamento.idgrade,
                dataInicio: reagendamento.dataInicio,
                dataFinal: reagendamento.dataFinal,
                valor: reagendamento.valor,
                valorPromocional: reagendamento.valorPromocional,
                promocao: reagendamento.promocao,
                nobre: reagendamento.nobre,
                status: reagendamento.status,
                idHorario: reagendamento.idHorario,
              },
            ]}
          />
        )}
        {selectedTab === 1 && (
          <ResumoAgendamento
            horario={sttCtxChkt.agendamentoConfirme.agenda}
            data={sttCtxChkt.agendamentoConfirme.agenda[0].dataInicio}
            nomeEmpresa={sttPg.empresa?.nome}
            nomeQuadra={sttCtxChkt.agendamentoConfirme.quadra.descricao}
            endereco={sttCtxChkt.agendamentoConfirme.quadra.endereco}
            sttCtxChkt={sttCtxChkt}
            sttPg={sttPg}
          />
        )}
      </Grid>

      <Grid item xs={12} padding={'0px'}>
        <Typography variant='h6' className='text-title-section'>
          Opções adicionais
        </Typography>
      </Grid>
      <Grid item xs={12} padding={'0px'}>
        <ButtonAction
          title={'Observações do Agendamento'}
          titleLabel={observacao.length ? 'Observação' : 'Que tal adicionar uma observação?'}
          text={observacao}
          confirmed={observacao.length ? true : false}
          onClick={() => {
            setModalObs(true)
          }}
        />
      </Grid>

      <Grid item xs={12} padding={'0px'}>
        {Object.keys(reagendamento).length === 0 && (
          <ButtonAction
            title={'Configurar um horário fixo'}
            titleLabel={
              sttCtxChkt.horaFixaSelecionada === null ? 'É um horário fixo?' : 'Horário fixo'
            }
            text={
              sttCtxChkt.horaFixaSelecionada
                ? `${sttCtxChkt.horaFixaSelecionada.tipoMensalista}, começa em ${moment(
                    sttCtxChkt.horaFixaSelecionada.dataInicio,
                  ).format('DD/MM/YY')}`
                : ''
            }
            confirmed={sttCtxChkt.horaFixaSelecionada ? true : false}
            onClick={() => {
              actionsChkt.handleModaisChkt('horaFx', true)
            }}
          />
        )}
      </Grid>

      {sttCtxChkt.horaFixaSelecionada === null && (
        <>
          <Grid item xs={12}>
            <Typography variant='h6' className='text-title-section'>
              {Object.keys(reagendamento).length === 0 ? 'Como você deseja pagar?' : 'Pagamento'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {Object.keys(reagendamento).length > 0 &&
            !pagamentoLocal &&
            reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
              <Typography>
                {reagendamento.valorTotal !== reagendamento.valorAPagar &&
                reagendamento.valorRealizado !== 0 &&
                reagendamento.valorAPagar !== 0 ? (
                  <span>
                    Este reagendamento não terá custos adicionais neste momento, pois o sinal no
                    valor de{' '}
                    <strong>
                      R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                    </strong>{' '}
                    já foi previamente pago no agendamento original.
                  </span>
                ) : reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
                  <span>
                    Este reagendamento não terá custos adicionais, pois o valor de{' '}
                    <strong>
                      R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                    </strong>{' '}
                    já foi previamente pago no agendamento original.
                  </span>
                ) : (
                  <span>
                    Este reagendamento não terá custos adicionais, pois o valor de{' '}
                    <strong>
                      R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                    </strong>{' '}
                    já foi previamente pago no agendamento original.
                  </span>
                )}
              </Typography>
            ) : (
              <>
                {!sttCtxChkt.selSinal &&
                  (sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                    'AMBOS' ||
                    sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                      'TOTAL') && (
                    <ButtonAction
                      title={'Selecionar modo de pagamento'}
                      titleLabel='Total'
                      pay={'formaPagamento'}
                      text={
                        'R$ ' +
                        sttCtxChkt.agendamentoConfirme.valorTotal
                          .toFixed(2)
                          .toString()
                          .replace('.', ',')
                      }
                      confirmed={sttCtxChkt.selTotal}
                      onClick={() => actionsChkt.selectTotalPay()}
                    />
                  )}
                {Object.keys(reagendamento).length === 0 &&
                  sttCtxChkt.horaFixaSelecionada === null &&
                  !sttCtxChkt.selTotal &&
                  (sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                    'AMBOS' ||
                    sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                      'SINAL') && (
                    <ButtonAction
                      pay={'formaPagamento'}
                      title={'Selecionar modo de pagamento'}
                      titleLabel={`${sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.porcentagemSinal}% do valor do horário`}
                      text={`R$${Services.ReturnValorPorcentagem(
                        sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.porcentagemSinal,
                        sttCtxChkt.agendamentoConfirme.valorTotal,
                      )
                        .toString()
                        .replace('.', ',')}`}
                      confirmed={sttCtxChkt.selSinal}
                      onClick={() => actionsChkt.selectSinalPay()}
                    />
                  )}
              </>
            )}
          </Grid>
        </>
      )}
      <Divider sx={{ my: 2 }} />
      {Object.keys(reagendamento).length > 0 &&
      !pagamentoLocal &&
      reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
        <></>
      ) : (
        (sttCtxChkt.selTotal || sttCtxChkt.selSinal) && (
          <>
            <Grid item xs={12} marginTop={'5px'}>
              <Typography variant='h6' className='text-title-section'>
                Qual a forma de pagamento?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              {sttCtxChkt.horaFixaSelecionada === null ? (
                <>
                  {recebimentoPix &&
                    !sttCtxChkt.selDinheiro &&
                    !sttCtxChkt.selMaqCredit &&
                    !sttCtxChkt.selCardCredit && (
                      <ButtonAction
                        Icon={iconsPayment.logoPix}
                        titleLabel='PIX'
                        text='Pague pelo site'
                        disabled={
                          pagamentosDisponiveis.pix === 'limiteDias' || !pagamentosDisponiveis.pix
                        }
                        unavailableMessage={
                          pagamentosDisponiveis.pix === 'limiteDias'
                            ? 'Pix indisponivel para agendamentos com mais de 4 meses de antecedência'
                            : !pagamentosDisponiveis.pix
                              ? 'Pix indisponivel no momento'
                              : ''
                        }
                        pay={'payMetod'}
                        confirmed={sttCtxChkt.selPix}
                        sx={
                          Object.keys(reagendamento).length > 0 &&
                          pagamentoLocal && { opacity: 0.5 }
                        }
                        onClick={() => {
                          Object.keys(reagendamento).length > 0
                            ? avoidPaymentChange(
                                pagamentoLocal &&
                                  'Ainda não é possível alterar um reagendamento para pagamento online',
                              )
                            : actionsChkt.selectModePay('pix')
                        }}
                      />
                    )}
                  {recebimentoCartao &&
                    !sttCtxChkt.selPix &&
                    !sttCtxChkt.selDinheiro &&
                    !sttCtxChkt.selMaqCredit && (
                      <ButtonAction
                        Icon={iconsPayment.creditCard}
                        titleLabel='Cartão de Crédito'
                        text='Pague pelo site'
                        disabled={
                          pagamentosDisponiveis.cartao === 'limiteDias' ||
                          !pagamentosDisponiveis.cartao
                        }
                        unavailableMessage={
                          pagamentosDisponiveis.cartao === 'limiteDias'
                            ? 'Cartão de crédito indisponivel para agendamentos com mais de 28 dias de antecedência'
                            : !pagamentosDisponiveis.cartao
                              ? 'Cartão de crédito indisponivel no momento'
                              : ''
                        }
                        pay={'payMetod'}
                        confirmed={sttCtxChkt.selCardCredit}
                        sx={
                          Object.keys(reagendamento).length > 0 &&
                          pagamentoLocal && { opacity: 0.5 }
                        }
                        onClick={() => {
                          if (sttCtxChkt.selCardCredit) {
                            Object.keys(reagendamento).length > 0
                              ? avoidPaymentChange(
                                  pagamentoLocal &&
                                    'Ainda não é possível alterar um reagendamento para pagamento online',
                                )
                              : actionsChkt.selectModePay('card')
                          } else {
                            Object.keys(reagendamento).length > 0
                              ? avoidPaymentChange(
                                  pagamentoLocal &&
                                    'Ainda não é possível alterar um reagendamento para pagamento online',
                                )
                              : actionsChkt.handleModaisChkt('cartaoCredito', true)
                          }
                        }}
                      />
                    )}
                </>
              ) : null}
              {recebimentoDinheiro &&
                !sttCtxChkt.selSinal &&
                !sttCtxChkt.selPix &&
                !sttCtxChkt.selMaqCredit &&
                !sttCtxChkt.selCardCredit && (
                  <ButtonAction
                    Icon={iconsPayment.payColor}
                    titleLabel='Dinheiro'
                    pay={'payMetod'}
                    text='Pague no local'
                    confirmed={sttCtxChkt.selDinheiro}
                    onClick={() => {
                      actionsChkt.selectModePay('dinheiro')
                    }}
                  />
                )}
              {recebimentoMaq &&
                !sttCtxChkt.selSinal &&
                !sttCtxChkt.selPix &&
                !sttCtxChkt.selDinheiro &&
                !sttCtxChkt.selCardCredit && (
                  <ButtonAction
                    Icon={iconsPayment.payTerminal}
                    titleLabel='Máquina de Cartão'
                    text='Pague no local'
                    pay={'payMetod'}
                    confirmed={sttCtxChkt.selMaqCredit}
                    onClick={() => {
                      actionsChkt.selectModePay('maq')
                    }}
                  />
                )}
            </Grid>
          </>
        )
      )}
      <Grid item xs={12} sx={stMob.containRowLabel}>
        <Typography variant='h6' className='text-title-section'>
          Esporte
        </Typography>
      </Grid>
      <Grid item xs={12} sx={stMob.containListEsportes}>
        {sttPg.selectedQuadra.categoriasEsporte.map((categoria, index) => (
          <React.Fragment key={index}>
            <CompEsporte
              categoria={categoria}
              selected={
                sttCtxChkt.esporteSelected?.idcategoriaEsporte === categoria.idcategoriaEsporte
              }
              onClick={() => {
                if (
                  sttCtxChkt.esporteSelected?.idcategoriaEsporte === categoria.idcategoriaEsporte
                ) {
                  actionsChkt.handleSttCtxChkt('esporteSelected', null)
                } else {
                  actionsChkt.handleSttCtxChkt('esporteSelected', categoria)
                }
              }}
            />
          </React.Fragment>
        ))}
      </Grid>
      <ChktBottom containRef={containRef} observacao={observacao} />
    </Grid>
  )
}

const stMob = {
  containInfosPedido: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  containRowLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    paddingTop: '7px',
  },
  // containNovidade: {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   marginLeft: '10px',
  // },
  //   <Box sx={stMob.containNovidade}>
  //   <Typography variant='h6' sx={stMob.textNovidade}>
  //     NOVIDADE
  //   </Typography>
  // </Box>
  // textNovidade: {
  //   backgroundColor: '#6c5aff',
  //   fontFamily: 'var(--font-jost-mediun)',
  //   fontSize: '11px',
  //   color: 'white',
  //   borderRadius: 'var(--border-radius-mid) 0px var(--border-radius-mid) 0px',
  //   padding: '5px 10px',
  // },
  containListEsportes: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
    width: 'auto',
    height: 'auto',
    overflowX: 'scroll',
    padding: '10px 0',
    '&::-webkit-scrollbar': {
      display: 'none',
    },

    '&:hover': {
      overflowX: 'auto',
    },
  },
}
